import angular from 'angular'

import { safeAssign } from '../utils/bits'
import { unsortedIsEqual } from '../utils/arrayh'
import { keys, cloneDeep } from 'lodash-es'

angular
  .module('ggs')
  .decorator('galleryRpc', FakeServerDecorator)

const FAKE_BOOTSTRAP = {
  displayed_item: null,
  top_posts: [],
  properties: {}
}

function FakeServerDecorator($q, qh, $log, $delegate) {
  const fakeMethods = {
    getTopPosts: FakePostMethod('getTopPosts'),
    getBelowPosts: FakePostMethod('getBelowPosts'),
    getAbovePosts: FakePostMethod('getAbovePosts'),
    getBootstrapData: FakeBootstrapMethod('getBootstrapData')
  }

  let enabled = false

  return safeAssign($delegate, fakeMethods, {
    $$getFakeBootstrap,
    $$enableFakeServer,
    $$disableFakeServer,
    $$isFakeServerEnabled
  })

  function $$getFakeBootstrap() {
    return cloneDeep(FAKE_BOOTSTRAP)
  }

  function $$enableFakeServer() {
    enabled = true
    return $delegate
  }

  function $$disableFakeServer() {
    enabled = false
    return $delegate
  }

  function $$isFakeServerEnabled() {
    return enabled
  }

  function FakeBootstrapMethod(methodName) {
    const origMethod = $delegate[methodName]
    return fakeMethod

    function fakeMethod() {
      if (enabled) {
        return $q.resolve(cloneDeep(FAKE_BOOTSTRAP))
      }

      return origMethod.apply(null, arguments).then(qh.tap((bootstrap) => {
        const realKeys = keys(bootstrap)
        const fakeKeys = keys(FAKE_BOOTSTRAP)
        if (!unsortedIsEqual(realKeys, fakeKeys)) {
          $log.warn('FakeServerDecorator: fake bootstrap requires an update!')
        }
      }))
    }
  }

  function FakePostMethod(methodName) {
    const origMethod = $delegate[methodName]
    return fakeMethod

    function fakeMethod() {
      if (enabled) {
        return $q.resolve([])
      }

      return origMethod.apply(null, arguments)
    }
  }
}
